<template>
<div>
    <div v-if="loading" class="loading-spin">
        <SpinnerLoader :color="'#3c5d3d'" />
    </div>
    <div v-else :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333'}" class="outer">
        <div v-if="showModal && dataLocationSingle" id="myModal" class="modal">
            <div class="modal-content flex-col">
                <h3>{{ dataLocationSingle.attributes.field_name }}</h3>
                <p :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">{{ dataLocationSingle.attributes.content_translation_source }}</p>
                <h5 v-if="lang === 'ru'">Услуги</h5>
                <h5 v-if="lang === 'kk'">Қызметтер</h5>
                <ul :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">
                    <li>Гинекология</li>
                    <li>Уролог</li>
                    <li>Психолог</li>
                    <li>Гинекология</li>
                </ul>
                <h5 v-if="lang === 'ru'" class="contacts">Контакты</h5>
                <h5 v-if="lang === 'kk'" class="contacts">Байланыс ақпараты</h5>
                <div class="label flex-row">
                    <svg style="margin-top: 4px" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 1.65e-05C3.67727 -0.00337064 2.408 0.514851 1.46982 1.44122C0.53232 2.36815 0.00334545 3.62643 0 4.94065C0 7.67068 3.74996 14 5 14C6.25004 14 10 7.67068 10 4.94065C9.99659 3.62646 9.46761 2.36814 8.53018 1.44122C7.59212 0.514851 6.32276 -0.00336515 5 1.65e-05ZM5 6.48512C4.20397 6.48512 3.4864 6.00867 3.18182 5.27819C2.87727 4.54715 3.04545 3.70601 3.60852 3.14718C4.17103 2.58774 5.01761 2.42066 5.7534 2.72323C6.48863 3.02581 6.96817 3.73878 6.96817 4.52966C6.96817 5.60958 6.08692 6.4851 5.00003 6.4851L5 6.48512Z" fill="#4F4F4F"/>
                    </svg>
                    <span>{{ dataLocationSingle.attributes.field_address_field_1 }}</span>
                </div>
                <div class="label flex-row">
                    <svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.6709 10.4581L11.2316 9.08449C10.4185 8.62181 10.391 8.92544 9.53654 9.87971C9.32982 10.111 8.94394 10.7183 8.48915 10.6026C7.53824 10.3568 5.76045 8.89653 5.18163 8.23143C4.906 7.91334 3.7208 6.39518 3.70702 5.90359C3.67946 5.15174 5.25054 4.77582 4.74062 3.34441L3.6519 0.785236C2.63208 -1.67273 -0.220666 2.26002 0.0136171 4.09626C0.619997 8.62181 8.18597 15.9379 12.4031 13.5233C13.3402 12.9739 14.6081 11.0509 13.6709 10.4581Z" fill="#4F4F4F"/>
                    </svg>
                    <span>{{ dataLocationSingle.attributes.field_telephone }}</span>
                </div>
                <div class="label flex-row">
                    <svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0Z" fill="#4F4F4F"/>
                        <path d="M6.99987 1.3999C6.87107 1.3999 6.76654 1.5042 6.76654 1.63324V6.9999H3.26654C3.13774 6.9999 3.0332 7.1042 3.0332 7.23324C3.0332 7.36227 3.13774 7.46657 3.26654 7.46657H6.99987C7.12867 7.46657 7.2332 7.36227 7.2332 7.23324V1.63324C7.2332 1.5042 7.12867 1.3999 6.99987 1.3999Z" fill="#F2F2F2"/>
                    </svg>
                    <span>{{ dataLocationSingle.attributes.field_hours_of_operation }}</span>
                </div>
                <span v-if="lang === 'ru'" @click="showModal = false" :style="{ 'color': '#ffffff', 'background' : data.impairedRegime ? '#000000' : '#568357' }" class="close">Закрыть</span>
                <span v-if="lang === 'kk'" @click="showModal = false" :style="{ 'color': '#ffffff', 'background' : data.impairedRegime ? '#000000' : '#568357' }" class="close">Жабу</span>
            </div>
        </div>
        <div v-show="showCity" id="myModal" class="modal">
            <div v-if="showCityList" class="modal-content-city-list flex-col">
                <h3 v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">Выберите ваш город</h3>
                <h3 v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">Өз қалаңызды таңдаңыз</h3>
                <div class="city-list flex-row">
                    <div @click="changeCity(item)" v-for="item in cities" :key="item" :style="{ 'color' : data.impairedRegime ? '#000000' : '#828282' }" v-bind:class="{ active: city == item}">
                        <svg style="left: -16px; position: absolute;" v-if="item == city" width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.99998 0C4.31998 0 0.599976 3.72 0.599976 8.4C0.599976 14.64 8.99998 24 8.99998 24C8.99998 24 17.4 14.64 17.4 8.4C17.4 3.72 13.68 0 8.99998 0ZM8.99998 11.4C7.31998 11.4 5.99998 10.08 5.99998 8.4C5.99998 6.72 7.31998 5.4 8.99998 5.4C10.68 5.4 12 6.72 12 8.4C12 10.08 10.68 11.4 8.99998 11.4Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                        </svg>
                        {{ item }}
                    </div>
                </div>
                <span v-if="lang === 'ru'" @click="showCity = false; showCityList = false" :style="{ 'color': '#ffffff', 'background' : data.impairedRegime ? '#000000' : '#568357' }" class="close">Готово</span>
                <span v-if="lang === 'kk'" @click="showCity = false; showCityList = false" :style="{ 'color': '#ffffff', 'background' : data.impairedRegime ? '#000000' : '#568357' }" class="close">Дайын</span>
            </div>
            <div v-else class="modal-content-city flex-col">
                <img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" data-src="/media/location/world_connection.png" alt="" class="lazyload">
                <img v-else data-src="/media/location/world_connection.png" alt="" class="lazyload">
                <span v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">Ваш город {{ city }}?</span>
                <span v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">Сіздің қалаңыз {{ city }}</span>
                <div class="feedback-btns flex-row">
                    <div v-if="lang === 'ru'" :style="{ 'background' : data.impairedRegime ? '#000000' : '#568357', 'color' : '#ffffff', 'border-color' : data.impairedRegime ? '#000000' : '#ffffff' }" @click="showCity = false" class="option yes">Да</div>
                    <div v-if="lang === 'kk'" :style="{ 'background' : data.impairedRegime ? '#000000' : '#568357', 'color' : '#ffffff', 'border-color' : data.impairedRegime ? '#000000' : '#ffffff' }" @click="showCity = false" class="option yes">Иә</div>
                    <div v-if="lang === 'ru'" :style="{ 'background' : '#ffffff', 'color' : data.impairedRegime ? '#000000' : '#568357', 'border-color' : data.impairedRegime ? '#000000' : '#568357' }" @click="showCityList = true" class="option no">Нет</div>
                    <div v-if="lang === 'kk'" :style="{ 'background' : '#ffffff', 'color' : data.impairedRegime ? '#000000' : '#568357', 'border-color' : data.impairedRegime ? '#000000' : '#568357' }" @click="showCityList = true" class="option no">Жоқ</div>
                </div>
            </div>
        </div>
        <directory :route="$route"></directory>
        <div class="flex-row" style="position: relative">
            <div :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#F0DCC4'}" class="left flex-col">
                <div @click="showCity = true;" class="location flex-row">
                    <svg style="margin-top: 4px;" width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99961 0C4.31961 0 0.599609 3.72 0.599609 8.4C0.599609 14.64 8.99961 24 8.99961 24C8.99961 24 17.3996 14.64 17.3996 8.4C17.3996 3.72 13.6796 0 8.99961 0ZM8.99961 11.4C7.31961 11.4 5.99961 10.08 5.99961 8.4C5.99961 6.72 7.31961 5.4 8.99961 5.4C10.6796 5.4 11.9996 6.72 11.9996 8.4C11.9996 10.08 10.6796 11.4 8.99961 11.4Z" :fill="data.impairedRegime ? '#ffffff' : '#568357'"/>
                    </svg>
                    <span :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#568357' }">{{ city }}</span>
                </div>
                <h1 v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#333333' }">Молодёжные Центры здоровья в {{ city }}</h1>
                <h1 v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#333333' }">{{ city }} қаласындағы медициналық орталықтар</h1>
                <p v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#4F4F4F' }">Все МЦЗ медицинской, медико-психологической, юридической и консультативной помощи по Республики Казахстан</p>
                <p v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#4F4F4F' }">Қазақстан Республикасы бойынша Медициналық, медициналық-психологиялық, заң және консультативтік көмек көрсететін барлық ЖДО</p>
                <div class="search">
                    <div class="search-icon">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" :fill="data.impairedRegime ? '#000000' : '#568357'"/>
                        </svg>
                    </div>
                    <input v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#333333' }" v-model="searchText" type="text" placeholder="Поиск названиям услуг, медицинских центров...">
                    <input v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#333333' }" v-model="searchText" type="text" placeholder="Қызмет атауларын, медициналық орталықтарды іздеу...">
                    <span v-show="searchText" v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#333333' }">Найдено: {{ dataLocations.length }}</span>
                    <span v-show="searchText" v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#333333' }">Іздеу нәтижесі: {{ dataLocations.length }}</span>
                </div>
                <div class="locate-list flex-col">
                    <div @click="showModal = true; dataLocationSingle = location" v-for="location in dataLocations.filter( item => item.attributes.field_city == city )" :key="location.id" class="locate flex-col">
                        <h3>{{ location.attributes.field_name }}</h3>
                        <ul :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">
                            <li>Гинекология</li>
                            <li>Уролог</li>
                            <li>Психолог</li>
                            <li>Гинекология</li>
                            <li>Уролог</li>
                        </ul>
                        <div class="label flex-row">
                            <svg style="margin-top: 4px" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1.65e-05C3.67727 -0.00337064 2.408 0.514851 1.46982 1.44122C0.53232 2.36815 0.00334545 3.62643 0 4.94065C0 7.67068 3.74996 14 5 14C6.25004 14 10 7.67068 10 4.94065C9.99659 3.62646 9.46761 2.36814 8.53018 1.44122C7.59212 0.514851 6.32276 -0.00336515 5 1.65e-05ZM5 6.48512C4.20397 6.48512 3.4864 6.00867 3.18182 5.27819C2.87727 4.54715 3.04545 3.70601 3.60852 3.14718C4.17103 2.58774 5.01761 2.42066 5.7534 2.72323C6.48863 3.02581 6.96817 3.73878 6.96817 4.52966C6.96817 5.60958 6.08692 6.4851 5.00003 6.4851L5 6.48512Z" fill="#4F4F4F"/>
                            </svg>
                            <span>{{ location.attributes.field_address_field_1 }}</span>
                        </div>
                        <div class="label flex-row">
                            <svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6709 10.4581L11.2316 9.08449C10.4185 8.62181 10.391 8.92544 9.53654 9.87971C9.32982 10.111 8.94394 10.7183 8.48915 10.6026C7.53824 10.3568 5.76045 8.89653 5.18163 8.23143C4.906 7.91334 3.7208 6.39518 3.70702 5.90359C3.67946 5.15174 5.25054 4.77582 4.74062 3.34441L3.6519 0.785236C2.63208 -1.67273 -0.220666 2.26002 0.0136171 4.09626C0.619997 8.62181 8.18597 15.9379 12.4031 13.5233C13.3402 12.9739 14.6081 11.0509 13.6709 10.4581Z" fill="#4F4F4F"/>
                            </svg>

                            <span>{{ location.attributes.field_telephone }}</span>
                        </div>
                        <div class="label flex-row">
                            <svg style="margin-top: 4px" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 0 7 0Z" fill="#4F4F4F"/>
                                <path d="M6.99987 1.3999C6.87107 1.3999 6.76654 1.5042 6.76654 1.63324V6.9999H3.26654C3.13774 6.9999 3.0332 7.1042 3.0332 7.23324C3.0332 7.36227 3.13774 7.46657 3.26654 7.46657H6.99987C7.12867 7.46657 7.2332 7.36227 7.2332 7.23324V1.63324C7.2332 1.5042 7.12867 1.3999 6.99987 1.3999Z" fill="#F2F2F2"/>
                            </svg>
                            <span>{{ location.attributes.field_hours_of_operation }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div :style="{ 'filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)' }" class="right">
                <gmap-map
                    :center="center"
                    :zoom="11"
                    style="width: 100%; height: 100%"
                    :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUI: false
                    }"	
                >
                    <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    :title="m.title"
                    :draggable="false"
                    @click="center=m.position"
                    ></gmap-marker>
                </gmap-map>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { api } from '../../variables.js'

export default {
    props: [ 'data' ],
    data(){
        return {
            searchText: '',
            showModal: false,
            showCity: false,
            showCityList: false,
            dataLocations: '',
            dataAllLocations: [],
            dataLocationSingle: '',
            cities: [],
            city: '',
            center: {lat: 43.23267859852702, lng: 76.90966259775811},
            markers: [],
            lang: 'kk',
            loading: false
        }
    },
    created: function () {
        if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
		}
        this.getLocations()
    },
    watch: {
        searchText: function(text) {
            text = text.toLowerCase().split(' ');
            this.dataLocations = this.dataAllLocations.filter(function(item) {
                return text.every(function(el) {
                    return item.attributes.field_name.toLowerCase().indexOf(el) > -1;
                });
            });
        }
    },
    methods: {
        getLocations(){
            this.loading = true
            axios.get( api + '/mhealth/jsonapi/node/srh_service_provider/?filter[field_country.name]=KAZ&sort=created&page[offset]=0&include=field_service_provided' )
            .then((res) => {
                var cities = new Set()
                var locs = new Set()
                this.dataLocations = res.data.data
                this.dataLocations.forEach( item => {
                    cities.add( item.attributes.field_city )
                })
                this.cities = Array.from(cities)
                if(localStorage.getItem('unCityName')){
                    this.city = localStorage.getItem('unCityName');
                } else {
                    this.city = 'Nur-Sultan'
                    localStorage.setItem('unCityName', this.city);
                }
                var lat = 0, lng = 0, count = 0;
				this.dataLocations.forEach( item => {
                    if(item.attributes.field_city == this.city){
                        locs.add(item) 
                        count++
                        this.markers.push({
                            position: {
                                lat: Number(item.attributes.field_latitude),
                                lng: Number(item.attributes.field_longitude)
                            },
                            title: item.attributes.field_name
                        })
                        lat += Number(item.attributes.field_latitude)
                        lng += Number(item.attributes.field_longitude)
                    }
				})
				this.center = {
					lat: Number((lat / count).toPrecision(6)),
					lng: Number((lng / count).toPrecision(6))
                }
                this.dataAllLocations = Array.from(locs)
                this.loading = false
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        changeCity(item){   
            localStorage.setItem('unCityName', item);
            location.reload()
        }
    }
}
</script>
<style lang="scss" scoped>
    *{
        transition: all 0.6s ease;
    }
    h1, h3, h5, p, span, a, label{
        cursor: default;
        text-decoration: none;
        text-align: left;
        margin: 0;
    }
    .modal{
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background: rgba(51, 51, 51, 0.4);  
        .modal-content {
            position: relative;
            background: #FFFFFF;
            box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
            border-radius: 10px;
            margin: 145px auto auto auto;
            padding: 30px 40px;
            width: 540px;
            height: 440px;
            h3{
                font-weight: 500;
                font-size: 20px;
                line-height: 156.61%;
                letter-spacing: -0.44px;
            }
            p{
                margin-top: 8px;
                font-weight: 300;
                font-size: 14px;
                line-height: 121.6%;
                letter-spacing: -0.44px;
            }
            h5{
                margin-top: 20px;
                font-weight: 500;
                font-size: 14px;
                line-height: 121.6%;
                letter-spacing: -0.44px;
            }
            h5.contacts{
                margin-top: 30px;
            }
            ul{
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                padding: 0 0 0 15px;
                margin: 0;
                li{
                    margin: 14px 30px 0 0;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 156.61%;
                    letter-spacing: -0.44px;
                }
            }
            .label{
                margin-top: 10px;
                span{
                    cursor: pointer;
                    margin-left: 14px;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 156.61%;
                    letter-spacing: -0.44px;
                }
            }
            .close{
                cursor: pointer;
                position: absolute;
                bottom: 30px;
                left: 119px;
                padding: 23px 0;
                width: 382px;
                border-radius: 10px;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 0.04em;
            }
        }
        .modal-content-city {
            position: relative;
            background: #FFFFFF;
            box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
            border-radius: 10px;
            margin: 145px auto auto auto;
            padding: 40px 80px;
            width: 360px;
            height: 246px;
            img{
                position: absolute;
                top: 20px;
                right: 80px;
                transform: scale(0.25) translateX(132%) translateY(-120%);
            }
            span{
                margin: 130px auto 30px auto;
                font-weight: 500;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: 0.04em;
            }
            .feedback-btns{
                margin-left: 30px;
                .option{
                    z-index: 99;
                    cursor: pointer;
                    margin: 0 10px;
                    text-align: center;
                    padding: 13px 0;
                    width: 120px;
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
                .option.yes{
                    border: 2px solid #FFFFFF;
                }
                .option.no{
                    border: 2px solid #568357;
                }
            }
        }
        .modal-content-city-list {
            position: relative;
            background: #FFFFFF;
            box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
            border-radius: 10px;
            margin: 145px auto auto auto;
            padding: 40px 79px 123px 79px;
            width: 443px;
            min-height: 237px;
            h3{
                font-weight: 500;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: 0.04em;
            }
            .city-list{
                flex-wrap: wrap;
                div{
                    position: relative;
                    cursor: pointer;
                    width: calc(33% - 24px);
                    margin: 10px 12px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    opacity: 0.8;
                }
                .active{
                    color: #568357;
                    font-weight: bold;
                }
            }
            .close{
                cursor: pointer;
                position: absolute;
                bottom: 30px;
                left: 133px;
                padding: 23px 0;
                width: 333px;
                border-radius: 10px;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 0.04em;
            }
        }
    }
    .outer{
        padding: 30px 0 80px 7%;
        transition: none;
        .left{
            height: 658px;
            padding: 12px 18px 0 18px;
            width: 484px;
            .location{
                cursor: pointer;
                span{
                    cursor: pointer;
                    margin-left: 14px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    opacity: 0.8;
                }
            }
            h1{
                margin-top: 10px;
                font-weight: 500;
                font-size: 20px;
                line-height: 26px;
                letter-spacing: 0.04em;
            }
            p{
                margin-top: 8px;
                font-weight: 300;
                font-size: 14px;
                line-height: 17px;
                letter-spacing: 0.04em;
            }
            .search{
                position: relative;
                margin: 22px 0 20px 0;
                width: 100%;
                .search-icon{
                    cursor: pointer;
                    position: absolute;
                    left: 34px;
                    top: 19px;
                    opacity: 0.6;
                }
                span{
                    position: absolute;
                    right: 19px;
                    top: 22px;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 16px;
                    text-align: right;
                    letter-spacing: -0.0044em;
                }
                input{
                    width: calc(100% - 85px);
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 10px;
                    border: none;
                    padding: 14px 15px 14px 60px;
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 18px;
                    transition: width 0.5s;
                }
                input::placeholder{
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 18px;
                    opacity: 0.6;
                }
            }
            .locate-list{
                overflow-y: scroll;
                .locate{
                    cursor: pointer;
                    width: 420px;
                    margin-bottom: 16px;
                    background: #FFFFFF;
                    box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                    border-radius: 10px;
                    padding: 15px 20px;
                    h3{
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 156.61%;
                        letter-spacing: -0.44px;
                        color: #000000;
                    }
                    ul{
                        margin: 10px 0 6px 0;
                        display: flex;
                        flex-direction: row;
                        padding: 0 0 0 15px;
                        width: 400px;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: horizontal;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        li{
                            margin-left: 30px;
                            font-weight: 300;
                            font-size: 14px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                        }
                        li:first-of-type{
                            margin-left: 0;
                        }
                    }
                    .label{
                        margin-top: 10px;
                        span{
                            cursor: pointer;
                            margin-left: 14px;
                            font-weight: 300;
                            font-size: 14px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                        }
                    }
                }
            }
            ::-webkit-scrollbar {
                width: 6px;
            }
            ::-webkit-scrollbar-track {
                background: #ECF3F9;
                border-radius: 10px;
            }
            ::-webkit-scrollbar-thumb {
                background: #568357; 
                border-radius: 10px;
            }
        }
        .right{
            width: calc(100% - 520px);
            overflow: hidden;
            img{
                object-fit: contain;
            }
        }
    }
    @media only screen and (max-width: 1330px){
        .outer{
            padding: 30px 0 80px 6%;
            .left{
                height: 658px;
                padding: 12px 18px 0 18px;
                width: 364px;
                .location{
                    cursor: pointer;
                    span{
                        margin-left: 14px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                }
                h1{
                    margin-top: 10px;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 25px;
                    letter-spacing: 0.04em;
                }
                p{
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 17px;
                    letter-spacing: 0.04em;
                }
                .search{
                    position: relative;
                    margin: 22px 0 20px 0;
                    width: 100%;
                    .search-icon{
                        cursor: pointer;
                        position: absolute;
                        left: 34px;
                        top: 19px;
                        opacity: 0.6;
                    }
                    span{
                        position: absolute;
                        right: 19px;
                        top: 22px;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 16px;
                        text-align: right;
                        letter-spacing: -0.0044em;
                    }
                    input{
                        width: calc(100% - 85px);
                        height: 28px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        border: none;
                        padding: 14px 15px 14px 60px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        transition: width 0.5s;
                    }
                    input::placeholder{
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        opacity: 0.6;
                    }
                }
                .locate-list{
                    overflow-y: scroll;
                    .locate{
                        cursor: pointer;
                        width: 280px;
                        margin-bottom: 16px;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 15px 20px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                            color: #000000;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: 260px;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
                }
                ::-webkit-scrollbar {
                    width: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #ECF3F9;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #568357; 
                    border-radius: 10px;
                }
            }
            .right{
                width: calc(100% - 320px);
                overflow: hidden;
                img{
                    object-fit: contain;
                }
            }
        } 
    }
    @media only screen and (max-width: 1024px){
        .outer{
            padding: 30px 6% 80px 6%;
            .left{
                margin-top: 300px;
                height: 458px;
                padding: 12px 18px 0 18px;
                width: calc(100% - 36px);
                .location{
                    cursor: pointer;
                    span{
                        margin-left: 14px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                }
                h1{
                    font-weight: 500;
                    font-size: 20px;
                    letter-spacing: 0.04em;
                }
                p{
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 17px;
                    letter-spacing: 0.04em;
                }
                .search{
                    display: none;
                    position: relative;
                    margin: 22px 0 20px 0;
                    width: 100%;
                    .search-icon{
                        cursor: pointer;
                        position: absolute;
                        left: 34px;
                        top: 19px;
                        opacity: 0.6;
                    }
                    span{
                        position: absolute;
                        right: 19px;
                        top: 22px;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 16px;
                        text-align: right;
                        letter-spacing: -0.0044em;
                    }
                    input{
                        width: calc(100% - 85px);
                        height: 28px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        border: none;
                        padding: 14px 15px 14px 60px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        transition: width 0.5s;
                    }
                    input::placeholder{
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 18px;
                        opacity: 0.6;
                    }
                }
                .locate-list{
                    flex-direction: row;
                    flex-wrap: wrap;
                    .locate{
                        cursor: pointer;
                        width: calc(46% - 40px);
                        margin: 10px 2% 16px 2%;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 15px 20px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                            color: #000000;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: calc(100% - 20px);
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
                }
                ::-webkit-scrollbar {
                    width: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #ECF3F9;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #568357; 
                    border-radius: 10px;
                }
            }
            .right{
                position: absolute;
                top: 0;
                height: 300px;
                width: calc(100%);
                overflow: hidden;
                img{
                    object-fit: contain;
                }
            }
        }
        .modal{
            .modal-content {
                position: relative;
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 85px auto auto auto;
                padding: 15px 20px;
                width: 380px;
                height: 420px;
                h3{
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 156.61%;
                    letter-spacing: -0.44px;
                }
                p{
                    margin-top: 8px;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 121.6%;
                    letter-spacing: -0.44px;
                }
                h5{
                    margin-top: 10px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 121.6%;
                    letter-spacing: -0.44px;
                }
                h5.contacts{
                    margin-top: 15px;
                }
                ul{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    padding: 0 0 0 15px;
                    margin: 0;
                    li{
                        margin: 14px 30px 0 0;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 156.61%;
                        letter-spacing: -0.44px;
                    }
                }
                .label{
                    margin-top: 10px;
                    span{
                        cursor: pointer;
                        margin-left: 14px;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 156.61%;
                        letter-spacing: -0.44px;
                    }
                }
                .close{
                    cursor: pointer;
                    position: absolute;
                    bottom: 15px;
                    left: 20px;
                    padding: 23px 0;
                    width: calc(100% - 40px);
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }
            .modal-content-city {
                position: relative;
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 145px auto auto auto;
                padding: 15px 20px;
                width: 320px;
                height: 220px;
                img{
                    position: absolute;
                    top: 20px;
                    right: 80px;
                    transform: scale(0.2) translateX(200%) translateY(-180%);
                }
                span{
                    margin: 110px auto 15px auto;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                }
                .feedback-btns{
                    margin-left: 15px;
                    .option{
                        z-index: 99;
                        cursor: pointer;
                        margin: 0 10px;
                        text-align: center;
                        padding: 13px 0;
                        width: 120px;
                        border-radius: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                    .option.yes{
                        border: 2px solid #FFFFFF;
                    }
                    .option.no{
                        border: 2px solid #568357;
                    }
                }
            }
            .modal-content-city-list {
                position: relative;
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 145px auto auto auto;
                padding: 20px 20px 90px 20px;
                width: 360px;
                min-height: 237px;
                h3{
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                }
                .city-list{
                    flex-wrap: wrap;
                    svg{
                        left: 16px !important;
                    }
                    div{
                        position: relative;
                        cursor: pointer;
                        width: calc(50% - 30px);
                        margin: 10px 15px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                    .active{
                        color: #568357;
                        font-weight: bold;
                    }
                }
                .close{
                    cursor: pointer;
                    position: absolute;
                    bottom: 20px;
                    left: 20px;
                    padding: 23px 0;
                    width: calc(100% - 40px);
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }
        } 
    }
    @media only screen and (max-width: 720px){
        .outer{
            padding: 20px 6% 60px 6%;
            .left{
                margin-top: 420px;
                height: 488px;
                padding: 12px 18px 0 18px;
                width: calc(100% - 36px);
                .location{
                    cursor: pointer;
                    margin-bottom: 10px;
                    span{
                        margin-left: 14px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                }
                h1{
                    position: absolute;
                    top: -10px;
                    left: 0;
                    margin-top: 0px;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 25px;
                    letter-spacing: 0.04em;
                }
                p{
                    position: absolute;
                    top: 40px;
                    left: 0;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 17px;
                    letter-spacing: 0.04em;
                    margin-bottom: 10px;
                }
                .locate-list{
                    flex-direction: row;
                    flex-wrap: wrap;
                    .locate{
                        cursor: pointer;
                        width: calc(96% - 28px);
                        margin: 0px 2% 16px 2%;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 8px 14px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                            color: #000000;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: calc(100% - 20px);
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
                }
                ::-webkit-scrollbar {
                    width: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #ECF3F9;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #568357; 
                    border-radius: 10px;
                }
            }
            .right{
                position: absolute;
                top: 120px;
                height: 300px;
                width: calc(100%);
                overflow: hidden;
                img{
                    object-fit: contain;
                }
            }
        } 
    }
    @media only screen and (max-width: 480px){
        .outer{
            padding: 20px 4% 60px 4%;
            .left{
                margin-top: 420px;
                height: 488px;
                padding: 12px 18px 0 18px;
                width: calc(100% - 36px);
                .location{
                    cursor: pointer;
                    margin-bottom: 10px;
                    span{
                        margin-left: 14px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                }
                h1{
                    position: absolute;
                    top: -10px;
                    left: 0;
                    margin-top: 0px;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 25px;
                    letter-spacing: 0.04em;
                }
                p{
                    position: absolute;
                    top: 40px;
                    left: 0;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 17px;
                    letter-spacing: 0.04em;
                    margin-bottom: 10px;
                }
                .locate-list{
                    flex-direction: row;
                    flex-wrap: wrap;
                    .locate{
                        cursor: pointer;
                        width: calc(96% - 28px);
                        margin: 0px 2% 16px 2%;
                        background: #FFFFFF;
                        box-shadow: 0px 8px 12px rgba(43, 42, 41, 0.05), 0px 10px 26px rgba(43, 42, 41, 0.05);
                        border-radius: 10px;
                        padding: 8px 14px;
                        h3{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 156.61%;
                            letter-spacing: -0.44px;
                            color: #000000;
                        }
                        ul{
                            margin: 10px 0 6px 0;
                            display: flex;
                            flex-direction: row;
                            padding: 0 0 0 15px;
                            width: calc(100% - 20px);
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: horizontal;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            li{
                                margin-left: 30px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                            li:first-of-type{
                                margin-left: 0;
                            }
                        }
                        .label{
                            margin-top: 10px;
                            span{
                                cursor: pointer;
                                margin-left: 14px;
                                font-weight: 300;
                                font-size: 14px;
                                line-height: 156.61%;
                                letter-spacing: -0.44px;
                            }
                        }
                    }
                }
                ::-webkit-scrollbar {
                    width: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #ECF3F9;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #568357; 
                    border-radius: 10px;
                }
            }
            .right{
                position: absolute;
                top: 120px;
                height: 300px;
                width: calc(100%);
                overflow: hidden;
                img{
                    object-fit: contain;
                }
            }
        } 
        .modal{
            .modal-content {
                position: relative;
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 85px auto auto auto;
                padding: 15px 20px;
                width: 280px;
                height: 380px;
                h3{
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 156.61%;
                    letter-spacing: -0.44px;
                }
                p{
                    margin-top: 8px;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 121.6%;
                    letter-spacing: -0.44px;
                }
                h5{
                    margin-top: 10px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 121.6%;
                    letter-spacing: -0.44px;
                }
                h5.contacts{
                    margin-top: 15px;
                }
                ul{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    padding: 0 0 0 15px;
                    margin: 0;
                    li{
                        margin: 14px 30px 0 0;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 12px;
                        letter-spacing: -0.44px;
                    }
                }
                .label{
                    margin-top: 10px;
                    span{
                        cursor: pointer;
                        margin-left: 14px;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 156.61%;
                        letter-spacing: -0.44px;
                    }
                }
                .close{
                    cursor: pointer;
                    position: absolute;
                    bottom: 15px;
                    left: 20px;
                    padding: 12px 0;
                    width: calc(100% - 40px);
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }
            .modal-content-city {
                position: relative;
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 145px auto auto auto;
                padding: 15px 20px;
                width: 240px;
                height: 200px;
                img{
                    position: absolute;
                    top: 20px;
                    right: 80px;
                    transform: scale(0.2) translateX(220%) translateY(-200%);
                }
                span{
                    margin: 90px auto 15px auto;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                }
                .feedback-btns{
                    margin-left: 0px;
                    .option{
                        z-index: 99;
                        cursor: pointer;
                        margin: 0 10px;
                        text-align: center;
                        padding: 13px 0;
                        width: 120px;
                        border-radius: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                    .option.yes{
                        border: 2px solid #FFFFFF;
                    }
                    .option.no{
                        border: 2px solid #568357;
                    }
                }
            }   
            .modal-content-city-list {
                position: relative;
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 145px auto auto auto;
                padding: 10px 15px 80px 15px;
                width: 280px;
                min-height: 237px;
                h3{
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                }
                .city-list{
                    flex-wrap: wrap;
                    overflow: scroll;
                    svg{
                        left: 0px !important;
                    }
                    div{
                        padding-left: 30px;
                        text-align: left;
                        position: relative;
                        cursor: pointer;
                        width: calc(100% - 30px);
                        margin: 4px 15px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                    .active{
                        color: #568357;
                        font-weight: bold;
                    }
                }
                .close{
                    cursor: pointer;
                    position: absolute;
                    bottom: 20px;
                    left: 20px;
                    padding: 12px 0;
                    width: calc(100% - 40px);
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }
        } 
    }
</style>


